(() => {
  const CARDS = [
    {
      id: "perma-card-1",
      title: "What is Permaculture?",
      summary: "In this page you can learn all about permaculture principles and practices, and ask questions to be answered by the community.",
      details:
        "Permaculture is widely defined as the practice of cultivating life in a way that mimics nature so as to work with, instead of against nature. It is less of a cultivation method and more of a worldview when understood properly. In the view of permaculture, grass lawns and monoculture fields are not only inefficient in cost and energy, but the more space becomes grass and monoculture, the more nature is pushed backed and life is degraded. Permaculture design seeks to create gardens, farms, storefronts, roadsides, and communities that are more like natural ecosystems, which are diverse, resilient, regenerative, and most importantly, easily sustainable with intent. This can involve techniques such as food forests, medicine gardens, pollinator gardens, vegetable gardens, beautiful paths, water harvesting, natural building, composting, seed saving, plant identification, and more. The goal of permaculture is to create sustainable and self-sufficient systems that provide for human needs while also supporting the health of the planet, while also learning what plants are invasive in areas and working to help restore the land to its healthy, abundant state everywhere possible.."
    },
    {
      id: "perma-card-2",
      title: "What is a Food Forest?",
      summary: "Learn what a food forest is and how you can get started in growing your own.",
      details:
        "Food Forests are large scale gardens involving many trees, usually fruit or nut trees. They are designed to mimic how natural forests grow, with understory trees and vines, clearly defined paths and access areas usually defined by some kind of ground cover, sunny areas for more light needy plants, dappled shade for those that thrive in it. In a Food Forest, the trees provide diverse microclimates, water runoff, and habitats for beneficial insects and animals that can be promoted to help with pest control and pollination. Food Forests can be designed in many different ways, but they all share the common goal of creating a sustainable and self-sufficient ecosystem that provides food, medicine, beauty, and many other resources for people, while also supporting the health of the planet and all that live on it. Key features to work out in Food Forests are the tree layout, water flow/irrigation, path layout, and plant selection. "
    },
    {
      id: "perma-card-3",
      title: "What is monoculture?",
      summary: "Learn the difference between monoculture and permaculture, and why unnatural monocultures can be ecologically harmful.",
      details:
        "Monoculture is the practice of growing a single crop species over a large area, wether it be for farming, attracting animals for hunting, invasive species aftermath, or even grass lawns. In nature it is very rare for monocultures to take place as sustained monocultures become target to pests and diseases, degrade the soil over time and take up space that could be used for a more diverse and resilient ecosystem. In contrast, permaculture emphasizes the importance of biodiversity and the use of natural systems to create sustainable and self-sufficient ecosystems. Monocultures can lead to soil degradation, loss of biodiversity, and increased vulnerability to pests and diseases. Permaculture practices, on the other hand, promote soil health, water conservation, and the use of natural pest control methods. By working with nature instead of against it, permaculture creates systems that last longer, produce more, and support the health of the planet."
    },
    {
      id: "perma-card-4",
      title: "What is companion planting?",
      summary: "Here you can understand what companion planting is and how it can be beneficial to all types of plants.",
      details:
        "Companion planting is the process of planting multiple different kinds of plants meant to help eachother thrive in one area. There are many different roles that plants can play in their own microclimates, such a nitrogen fixing plants, soil mining plants with deep taproots to pull nutrients to the top of the soil, stronger based plants like trees and shrubs to provide structure for vines and creeping plants and mosses to grow on, heavy blooming plants that attract pollinators so the other flowers in the garden also get reliably polliated, shade givers, water sharers, insect repellers, and beneficial insect hostplants and attarctors, and much more. Building an efficient companion planting system involves understanding your goals, challenges/struggles, and learning what plants can help eachother to produce a thriving ecosystem.",
    },
    {
      id: "perma-card-5",
      title: "How to choose a layout?",
      summary: "Start here if you want to create a permaculture garden but dont know where to start.",
      details: 
        "Path and planting layouts in permaculture gardens can take a great number of shapes and sizes and materials, there is no one size fits all. To choose your layout, first survey the land being worked on, and decide where your main access points need to be, and make sure your paths cross through those. After that, it is usually a matter of deciding how large of beds are wanted, where they fit in the land and what shape would be best, and finally choosing the materials that will define the difference in access paths to growing beds, wether it be stone, wood, concrete, or just defined levels of dirt, a clearly separated path and bed layout make a garden look much cleaner and more intentional."
    }
  ];

  const cardGrid = document.getElementById("cardGrid");
  const modalBackdrop = document.getElementById("cardModalBackdrop");
  const closeModalBtn = document.getElementById("closeModalBtn");
  const modalTitle = document.getElementById("modalTitle");
  const modalSummary = document.getElementById("modalSummary");
  const modalDetails = document.getElementById("modalDetails");
  const modalQaAccount = document.getElementById("modalQaAccount");
  const modalQaItems = document.getElementById("modalQaItems");
  const modalQaForm = document.getElementById("modalQaForm");
  const modalQaMessage = document.getElementById("modalQaMessage");
  const modalQaStatus = document.getElementById("modalQaStatus");

  if (
    !cardGrid ||
    !modalBackdrop ||
    !closeModalBtn ||
    !modalTitle ||
    !modalSummary ||
    !modalDetails ||
    !modalQaAccount ||
    !modalQaItems ||
    !modalQaForm ||
    !modalQaMessage ||
    !modalQaStatus
  ) {
    return;
  }

  let activeModalCardId = null;
  let currentUser = null;

  const token = () => localStorage.getItem("lnf_token");

  async function jsonFetch(url, options = {}) {
    const baseHeaders = { "Content-Type": "application/json" };
    const authToken = token();
    if (authToken) baseHeaders.Authorization = "Bearer " + authToken;
    const opts = {
      headers: { ...baseHeaders, ...(options.headers || {}) },
      ...options
    };
    const res = await fetch(url, opts);
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || `Request failed: ${res.status}`);
    }
    return res.status === 204 ? null : res.json();
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function initials(name) {
    const label = (name || "Account").trim();
    const parts = label.split(/\s+/).filter(Boolean);
    if (!parts.length) return "AC";
    return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
  }

  function setQaStatus(message, isError = false) {
    modalQaStatus.textContent = message || "";
    modalQaStatus.style.color = isError ? "var(--error)" : "";
  }

  function updateQaAccountLabel() {
    if (currentUser) {
      const name = currentUser.display_name || currentUser.username || "Account";
      modalQaAccount.textContent = `Posting as ${name}`;
      return;
    }
    modalQaAccount.innerHTML = 'Sign in to post to Q & A. <a href="profile.html">Sign in</a>';
  }

  async function loadCurrentUser() {
    if (!token()) {
      currentUser = null;
      updateQaAccountLabel();
      return;
    }
    try {
      currentUser = await jsonFetch("/api/auth/me");
    } catch {
      currentUser = null;
    }
    updateQaAccountLabel();
  }

  function renderCards() {
    cardGrid.innerHTML = CARDS.map((card) => {
      return `
        <article class="card" data-card-id="${card.id}">
          <div class="card-header">
            <button class="button secondary small open-modal-btn" type="button" data-open-id="${card.id}">Open</button>
          </div>
          <h3 class="card-title">${escapeHtml(card.title)}</h3>
          <p class="card-text">${escapeHtml(card.summary)}</p>
        </article>
      `;
    }).join("");
  }

  function renderModalQa(rows) {
    if (!rows.length) {
      modalQaItems.innerHTML = '<div class="empty-state">No questions yet. Start the thread.</div>';
      return;
    }
    modalQaItems.innerHTML = rows.map((item) => {
      const name = item.display_name || "Community member";
      return `
        <article class="qa-item">
          <div class="avatar">${initials(name)}</div>
          <div class="qa-bubble">
            <div class="qa-author">${escapeHtml(name)}</div>
            <div class="qa-text">${escapeHtml(item.body || "")}</div>
          </div>
        </article>
      `;
    }).join("");
  }

  async function loadModalQa(cardId) {
    try {
      const rows = await jsonFetch(`/api/permaculture/${encodeURIComponent(cardId)}/qa`);
      renderModalQa(Array.isArray(rows) ? rows : []);
    } catch (err) {
      console.error("load permaculture qa error:", err);
      modalQaItems.innerHTML = '<div class="empty-state">Could not load Q & A right now.</div>';
    }
  }

  async function openModal(cardId) {
    const card = CARDS.find((entry) => entry.id === cardId);
    if (!card) return;

    activeModalCardId = cardId;
    modalTitle.textContent = card.title;
    modalSummary.textContent = card.summary;
    modalDetails.textContent = card.details;
    setQaStatus("");
    modalQaItems.innerHTML = '<div class="empty-state">Loading Q & A...</div>';
    modalBackdrop.classList.add("open");
    modalBackdrop.setAttribute("aria-hidden", "false");
    loadCurrentUser();
    loadModalQa(cardId);
  }

  function closeModal() {
    activeModalCardId = null;
    modalQaForm.reset();
    setQaStatus("");
    modalBackdrop.classList.remove("open");
    modalBackdrop.setAttribute("aria-hidden", "true");
  }

  cardGrid.addEventListener("click", (event) => {
    const openBtn = event.target.closest(".open-modal-btn");
    if (!openBtn) return;
    openModal(openBtn.getAttribute("data-open-id"));
  });

  closeModalBtn.addEventListener("click", closeModal);
  modalBackdrop.addEventListener("click", (event) => {
    if (event.target === modalBackdrop) closeModal();
  });

  modalQaForm.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!activeModalCardId) return;

    const message = modalQaMessage.value.trim();
    if (!message) return;

    if (!token()) {
      setQaStatus("Please sign in before posting to Q&A.", true);
      return;
    }

    setQaStatus("Posting...");
    try {
      await jsonFetch(`/api/permaculture/${encodeURIComponent(activeModalCardId)}/qa`, {
        method: "POST",
        body: JSON.stringify({ body: message })
      });
      modalQaForm.reset();
      setQaStatus("Posted.");
      await loadModalQa(activeModalCardId);
    } catch (err) {
      console.error("post permaculture qa error:", err);
      const msg = String(err?.message || "");
      if (msg.includes("401") || msg.includes("Not signed in")) {
        setQaStatus("Please sign in before posting to Q&A.", true);
      } else {
        setQaStatus("Could not post right now. Try again.", true);
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modalBackdrop.classList.contains("open")) {
      closeModal();
    }
  });

  renderCards();
})();
